import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
    CommandDialog,
    CommandInput,
    CommandList,
    CommandEmpty,
    CommandGroup,
    CommandItem,
    CommandSeparator,
} from "@/components/ui/command";
import { NAV_GROUPS } from "@/config/navigation";

export default function CommandPalette({ open, onOpenChange }) {
    const navigate = useNavigate();

    useEffect(() => {
        const down = (e) => {
            if ((e.key === "k" || e.key === "K") && (e.metaKey || e.ctrlKey)) {
                e.preventDefault();
                onOpenChange(!open);
            }
        };
        document.addEventListener("keydown", down);
        return () => document.removeEventListener("keydown", down);
    }, [open, onOpenChange]);

    const go = (path) => {
        onOpenChange(false);
        navigate(path);
    };

    return (
        <CommandDialog open={open} onOpenChange={onOpenChange} data-testid="command-palette">
            <CommandInput placeholder="Search modules, actions, or ask Yug Brain…" data-testid="command-input" />
            <CommandList>
                <CommandEmpty>No results found.</CommandEmpty>
                {NAV_GROUPS.map((group, i) => (
                    <React.Fragment key={group.label}>
                        {i > 0 && <CommandSeparator />}
                        <CommandGroup heading={group.label}>
                            {group.items.map((item) => {
                                const Icon = item.icon;
                                return (
                                    <CommandItem
                                        key={item.id}
                                        value={item.label}
                                        onSelect={() => go(item.path)}
                                        data-testid={`command-${item.id}`}
                                    >
                                        <Icon className="mr-2 h-4 w-4" strokeWidth={1.5} />
                                        <span>{item.label}</span>
                                    </CommandItem>
                                );
                            })}
                        </CommandGroup>
                    </React.Fragment>
                ))}
            </CommandList>
        </CommandDialog>
    );
}
